import React from 'react' 
import { Link} from "react-router-dom";

export const GoBack = (props) => { 
    return (
        <>
          <Link to={props.linkdata}  className='backBtnBott'> <i className='fa fa-angle-left btnbackicon'></i> </Link> 
        </>
    );
};